import { render, staticRenderFns } from "./vod.vue?vue&type=template&id=609600c5"
import script from "./vod.vue?vue&type=script&lang=js"
export * from "./vod.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/category/vod.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports